import { Stack, Text } from "@chakra-ui/react";
import { useColorModeValue } from "../ui/color-mode";

const RichText = ({ subtitle, title, colorText, description, ...props }) => {
  const textColor = useColorModeValue("gray.600", "gray.500");
  const headingColor = useColorModeValue("#008080", "#66b2b2");

  const titleParts = title.split(colorText);

  return (
    <Stack textAlign="center" {...props}>
      <Text
        fontSize="lg"
        color="#008080"
        fontWeight="semibold"
        letterSpacing="widest"
      >
        {subtitle}
      </Text>
      <Text fontSize={{ base: "2xl", md: "4xl" }} fontWeight="bold">
        {titleParts[0]}{" "}
        <Text as="span" color={headingColor}>
          {colorText}
        </Text>{" "}
        {titleParts[1]}
      </Text>
      <Text
        fontSize={{ base: "md", md: "xl" }}
        fontWeight="600"
        color={textColor}
        {...props.descProps}
      >
        {description}
      </Text>
    </Stack>
  );
};

export default RichText;
